export default __webpack_public_path__ + "static/media/pr_c_06.82492f76.jpg";